import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-overlay',
  imports: [],
  templateUrl: './overlay.component.html',
  styleUrls: ['./overlay.component.scss'],
})
export class OverlayComponent {
  @Input()
  noSpinner!: boolean

  constructor() {}
}
